export enum ObservationType {
  ON_TIME = 'OnTime',
  DELAY = 'Delay',
}
